var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{class:{'invisible': _vm.isHidden},attrs:{"id":"tree-chart"}}),_c('NoData',{class:{'d-none': !_vm.isHidden},attrs:{"title":"请选择病例关系"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }